/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { FileOrFolderFromJSON, FileOrFolderUpdateToJSON, FolderCreateToJSON, SuggestionFromJSON, } from '../models/index';
/**
 *
 */
export class FilesApi extends runtime.BaseAPI {
    /**
     * Create a new folder.
     * Create Folder
     */
    createFolderApiV1FilesFolderIdPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['folderId'] == null) {
                throw new runtime.RequiredError('folderId', 'Required parameter "folderId" was null or undefined when calling createFolderApiV1FilesFolderIdPost().');
            }
            if (requestParameters['folderCreate'] == null) {
                throw new runtime.RequiredError('folderCreate', 'Required parameter "folderCreate" was null or undefined when calling createFolderApiV1FilesFolderIdPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/files/{folder_id}`.replace(`{${"folder_id"}}`, encodeURIComponent(String(requestParameters['folderId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: FolderCreateToJSON(requestParameters['folderCreate']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => FileOrFolderFromJSON(jsonValue));
        });
    }
    /**
     * Create a new folder.
     * Create Folder
     */
    createFolderApiV1FilesFolderIdPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createFolderApiV1FilesFolderIdPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Delete an existing file or folder.
     * Delete File
     */
    deleteFileApiV1FilesFileIdDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['fileId'] == null) {
                throw new runtime.RequiredError('fileId', 'Required parameter "fileId" was null or undefined when calling deleteFileApiV1FilesFileIdDelete().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/files/{file_id}`.replace(`{${"file_id"}}`, encodeURIComponent(String(requestParameters['fileId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete an existing file or folder.
     * Delete File
     */
    deleteFileApiV1FilesFileIdDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteFileApiV1FilesFileIdDeleteRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Record a download and redirect to the file served as an attachment.
     * Download File
     */
    downloadFileApiV1FilesFileIdDownloadGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['fileId'] == null) {
                throw new runtime.RequiredError('fileId', 'Required parameter "fileId" was null or undefined when calling downloadFileApiV1FilesFileIdDownloadGet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/files/{file_id}/download`.replace(`{${"file_id"}}`, encodeURIComponent(String(requestParameters['fileId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Record a download and redirect to the file served as an attachment.
     * Download File
     */
    downloadFileApiV1FilesFileIdDownloadGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.downloadFileApiV1FilesFileIdDownloadGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get breadcrumb for a file.
     * Get Breadcrumb
     */
    getBreadcrumbApiV1FilesFileIdBreadcrumbGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['fileId'] == null) {
                throw new runtime.RequiredError('fileId', 'Required parameter "fileId" was null or undefined when calling getBreadcrumbApiV1FilesFileIdBreadcrumbGet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/files/{file_id}/breadcrumb`.replace(`{${"file_id"}}`, encodeURIComponent(String(requestParameters['fileId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FileOrFolderFromJSON));
        });
    }
    /**
     * Get breadcrumb for a file.
     * Get Breadcrumb
     */
    getBreadcrumbApiV1FilesFileIdBreadcrumbGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getBreadcrumbApiV1FilesFileIdBreadcrumbGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get a file or folder by id.
     * Get File
     */
    getFileApiV1FilesFileIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['fileId'] == null) {
                throw new runtime.RequiredError('fileId', 'Required parameter "fileId" was null or undefined when calling getFileApiV1FilesFileIdGet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/files/{file_id}`.replace(`{${"file_id"}}`, encodeURIComponent(String(requestParameters['fileId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => FileOrFolderFromJSON(jsonValue));
        });
    }
    /**
     * Get a file or folder by id.
     * Get File
     */
    getFileApiV1FilesFileIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getFileApiV1FilesFileIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get root folder entity.
     * Get Root
     */
    getRootApiV1FilesRootGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/files/root`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => FileOrFolderFromJSON(jsonValue));
        });
    }
    /**
     * Get root folder entity.
     * Get Root
     */
    getRootApiV1FilesRootGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRootApiV1FilesRootGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get all chidren of a folder.
     * List Children
     */
    listChildrenApiV1FilesFolderIdChildrenGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['folderId'] == null) {
                throw new runtime.RequiredError('folderId', 'Required parameter "folderId" was null or undefined when calling listChildrenApiV1FilesFolderIdChildrenGet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/files/{folder_id}/children`.replace(`{${"folder_id"}}`, encodeURIComponent(String(requestParameters['folderId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FileOrFolderFromJSON));
        });
    }
    /**
     * Get all chidren of a folder.
     * List Children
     */
    listChildrenApiV1FilesFolderIdChildrenGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listChildrenApiV1FilesFolderIdChildrenGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * List recent files.
     * List Files
     */
    listFilesApiV1FilesGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['t'] != null) {
                queryParameters['t'] = requestParameters['t'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/files/`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FileOrFolderFromJSON));
        });
    }
    /**
     * List recent files.
     * List Files
     */
    listFilesApiV1FilesGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.listFilesApiV1FilesGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * List suggested files with the reason each is suggested, optionally scoped to a folder.
     * List Suggestions
     */
    listSuggestionsApiV1FilesSuggestionsGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['folderId'] != null) {
                queryParameters['folder_id'] = requestParameters['folderId'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/files/suggestions`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SuggestionFromJSON));
        });
    }
    /**
     * List suggested files with the reason each is suggested, optionally scoped to a folder.
     * List Suggestions
     */
    listSuggestionsApiV1FilesSuggestionsGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.listSuggestionsApiV1FilesSuggestionsGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Rename and/or move a file or folder.
     * Update File
     */
    updateFileApiV1FilesFileIdPatchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['fileId'] == null) {
                throw new runtime.RequiredError('fileId', 'Required parameter "fileId" was null or undefined when calling updateFileApiV1FilesFileIdPatch().');
            }
            if (requestParameters['fileOrFolderUpdate'] == null) {
                throw new runtime.RequiredError('fileOrFolderUpdate', 'Required parameter "fileOrFolderUpdate" was null or undefined when calling updateFileApiV1FilesFileIdPatch().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/files/{file_id}`.replace(`{${"file_id"}}`, encodeURIComponent(String(requestParameters['fileId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: FileOrFolderUpdateToJSON(requestParameters['fileOrFolderUpdate']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => FileOrFolderFromJSON(jsonValue));
        });
    }
    /**
     * Rename and/or move a file or folder.
     * Update File
     */
    updateFileApiV1FilesFileIdPatch(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateFileApiV1FilesFileIdPatchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Upload a file.
     * Upload File
     */
    uploadFileApiV1FilesFolderIdUploadPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['folderId'] == null) {
                throw new runtime.RequiredError('folderId', 'Required parameter "folderId" was null or undefined when calling uploadFileApiV1FilesFolderIdUploadPost().');
            }
            if (requestParameters['file'] == null) {
                throw new runtime.RequiredError('file', 'Required parameter "file" was null or undefined when calling uploadFileApiV1FilesFolderIdUploadPost().');
            }
            const queryParameters = {};
            if (requestParameters['force'] != null) {
                queryParameters['force'] = requestParameters['force'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = true;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['file'] != null) {
                formParams.append('file', requestParameters['file']);
            }
            const response = yield this.request({
                path: `/api/v1/files/{folder_id}/upload`.replace(`{${"folder_id"}}`, encodeURIComponent(String(requestParameters['folderId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => FileOrFolderFromJSON(jsonValue));
        });
    }
    /**
     * Upload a file.
     * Upload File
     */
    uploadFileApiV1FilesFolderIdUploadPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.uploadFileApiV1FilesFolderIdUploadPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Record a view and redirect to the file served inline.  The actual bytes are served by a presigned S3 URL; the backend only gatekeeps (auth), counts the access, and redirects. This is the single point where a view is counted — feeds the suggestions and the access metric.
     * View File
     */
    viewFileApiV1FilesFileIdViewGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['fileId'] == null) {
                throw new runtime.RequiredError('fileId', 'Required parameter "fileId" was null or undefined when calling viewFileApiV1FilesFileIdViewGet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/files/{file_id}/view`.replace(`{${"file_id"}}`, encodeURIComponent(String(requestParameters['fileId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Record a view and redirect to the file served inline.  The actual bytes are served by a presigned S3 URL; the backend only gatekeeps (auth), counts the access, and redirects. This is the single point where a view is counted — feeds the suggestions and the access metric.
     * View File
     */
    viewFileApiV1FilesFileIdViewGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.viewFileApiV1FilesFileIdViewGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
